module.exports = __webpack_public_path__ + "img/javieratoro.cfb6e385.jpg";